module.exports = __webpack_public_path__ + "img/sina-bank.c9224bf.svg";